var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"tfb-container",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"drop-shadow background-white tfb-smaller-container",attrs:{"fluid":""}},[_c('iframe',{staticClass:"autopayIFrame",attrs:{"src":_vm.autopayIFrameUrl,"title":"AutoPay Settings"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }